export const TRACKING_ROUTE_CONFIG = [
  { path: '/', pageName: 'HOME_PAGE' },
  { path: '/login', pageName: 'LOGIN_PAGE' },
  { path: '/po/pending', pageName: 'PENDING_PO' },
  { path: '/tnc/:status', pageName: 'TNC' },
  { path: '/po/details/:source/:purchaseOrderId', pageName: 'PO_DETAILS' },
  { path: '/ddPo/details/:source/:purchaseOrderId', pageName: 'DD_PO_DETAILS' },
  { path: '/ddPo/invoice/:purchaseOrderId', pageName: 'DD_PO_INVOICE' },
  { path: '/ddPo/pod/:purchaseOrderId/:orderId/:goTo', pageName: 'DD_PO_POD' },
  { path: '/ddPo/pod/v2/:purchaseOrderId/:orderId', pageName: 'DD_PO_POD_V2' },
  { path: '/grn/list', pageName: 'PENDING_GRN' },
  { path: '/grn/details/:source/:purchaseOrderId/:grnId', pageName: 'GRN_DETAILS' },
  { path: '/grn/invoice/:source/:purchaseOrderId/:grnId', pageName: 'GRN_INVOICE' },
  { path: '/grn/dispute/:source/:purchaseOrderId/:grnId', pageName: 'GRN_RAISE_DISPUTE' },
  { path: '/grn/creditNote/:grnId', pageName: 'CREDIT_NOTE' },
  { path: '/po/all', pageName: 'ALL_PO' },
  { path: '/ddPo/all', pageName: 'ALL_DD_PO' },
  { path: '/ddPo/:purchaseOrderId/buyer_orders', pageName: 'DD_PO_BUYER_ORDERS' },
  { path: '/po/service/:type', pageName: 'SERVICE_PO' },
  { path: '/po/service/all', pageName: 'ALL_SERVICE_PO' },
  { path: '/upload-documents/:purchaseOrderNumber', pageName: 'UPLOAD_DOCUMENTS' },
  { path: '/ddPo/generateEwb/:purchaseOrderId', pageName: 'GENERATE_EWB' },
  { path: '/ddPo/uploadDocs/:purchaseOrderId', pageName: 'UPLOAD_SUPPORTING_DOCS' },
  { path: '/grn-document-update/:grnNumber/:referenceNumber', pageName: 'REUPLOAD_INVOICE' },
  { path: '/user/verify-email', pageName: 'USER_VERIFY_EMAIL' },
];
